import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import React from 'react';
import { StyledBreadcrumb } from 'utils/styles';

interface Props {
  logout: () => void;
}

export const LogoutCrumb: React.FC<Props> = ({ logout }): JSX.Element => <StyledBreadcrumb label="Logout" icon={<ExitToAppIcon fontSize="small" />} onClick={logout} />;
